import React from 'react';
import { Check } from 'lucide-react';
import { useScore } from './ScoreContext';
interface Answer {
  id: string;
  label: string;
  text: string;
}
interface ReaderPathCheckProps {
  id: string;
  question: string;
  answers: Answer[];
  confirmationText?: string;
  checkLabel?: string;
}
export function ReaderPathCheck({
  id,
  question,
  answers,
  confirmationText = 'Saved. This is part of your score.',
  checkLabel = 'Quick Check'
}: ReaderPathCheckProps) {
  const {
    answers: globalAnswers,
    setAnswer
  } = useScore();
  const selectedId = globalAnswers[id] || null;
  return <div className="w-full bg-paper-dark border border-gray-200/70 rounded-3xl p-6 sm:p-8 md:p-12 my-16 shadow-[inset_0_2px_16px_rgba(26,40,56,0.05)] relative overflow-hidden" data-id="element-382">
      {/* Sea-glass instrument spine */}
      <div className="absolute top-6 bottom-6 left-0 w-1 md:w-1.5 rounded-r-full bg-seaglass" data-id="element-383"></div>

      <div className="pl-4 md:pl-6" data-id="element-384">
        <div className="flex items-center gap-2.5 mb-5" data-id="element-385">
          <div className="w-2 h-2 rounded-full bg-seaglass" data-id="element-386"></div>
          <span className="text-xs font-semibold uppercase tracking-[0.2em] text-seaglass" data-id="element-387">
            {checkLabel}
          </span>
        </div>

        <h3 className="text-2xl md:text-[2rem] font-serif text-navy mb-8 md:mb-10 leading-snug max-w-2xl" data-id="element-388">
          {question}
        </h3>

        <div className="flex flex-col gap-3" data-id="element-389">
          {answers.map(answer => {
          const isSelected = selectedId === answer.id;
          return <button key={answer.id} onClick={() => setAnswer(id, answer.id)} aria-pressed={isSelected} className={`w-full text-left p-5 md:p-6 rounded-2xl border transition-all duration-200 flex items-start gap-4 md:gap-5 min-h-[64px]
                  ${isSelected ? 'border-seaglass bg-seaglass/10 ring-1 ring-seaglass/40' : 'border-gray-200 bg-white hover:border-seaglass/50 hover:bg-white'}`} data-id="element-390">
                <div className={`flex-shrink-0 w-6 h-6 md:w-7 md:h-7 rounded-full border flex items-center justify-center mt-0.5 transition-colors
                  ${isSelected ? 'border-seaglass bg-seaglass text-white' : 'border-gray-300 bg-white text-transparent'}`} data-id="element-391">
                  <Check className="w-3.5 h-3.5" strokeWidth={3} data-id="element-392" />
                </div>
                <div className="flex-1" data-id="element-393">
                  <span className="font-serif font-semibold text-navy mr-2.5 text-lg" data-id="element-394">
                    {answer.label}.
                  </span>
                  <span className="text-text leading-relaxed" data-id="element-395">
                    {answer.text}
                  </span>
                </div>
              </button>;
        })}
        </div>

        {selectedId && <div className="mt-6 flex items-center gap-2.5 text-sm font-medium text-seaglass animate-in fade-in slide-in-from-top-2 duration-500" data-id="element-396">
            <Check className="w-4 h-4" strokeWidth={2.5} data-id="element-397" />
            <span data-id="element-398">{confirmationText}</span>
          </div>}
      </div>
    </div>;
}